// extracted by mini-css-extract-plugin
export default {"alertIcon":"Company_alertIcon__L-gf+","name":"Company_name__quCGp","logo":"Company_logo__YYeAh"};